import { Conflict } from '@/types/Conflicten';
import { Defect } from '@/types/Defecten';

import { VoorraadMapKnoop } from '../state/types/VoorraadbeheerStore';
import { Reserve } from '../types';

import usePlankTableStore from './usePlankTableStore';

export default function useTableKnoop(knoop: string): {
  mancos: Conflict[];
  verkeerdMat: Conflict[];
  defectenInzetbaar: Defect[];
  defectenBeperktInzetbaar: Defect[];
  defectenNietInzetbaar: Defect[];
  defectenInOnderhoud: Defect[];
  reserves: Reserve[];
  voorraadKnoop: VoorraadMapKnoop;
} {
  const mancos = usePlankTableStore((state) => state.mancosPerKnoop.get(knoop) ?? []);
  const verkeerdMat = usePlankTableStore((state) => state.verkeerdMatPerKnoop.get(knoop) ?? []);
  const defectenInzetbaar = usePlankTableStore((state) => state.defectenInzetbaarPerKnoop.get(knoop) ?? []);
  const defectenBeperktInzetbaar = usePlankTableStore(
    (state) => state.defectenBeperktInzetbaarPerKnoop.get(knoop) ?? [],
  );
  const defectenNietInzetbaar = usePlankTableStore((state) => state.defectenNietInzetbaarPerKnoop.get(knoop) ?? []);
  const defectenInOnderhoud = usePlankTableStore((state) => state.defectenInOnderhoudPerKnoop.get(knoop) ?? []);
  const reserves = usePlankTableStore((state) => state.reservesPerKnoop.get(knoop) ?? []);
  const voorraadKnoop = usePlankTableStore((state) => state.getVoorraadKnoop(knoop));

  return {
    mancos,
    verkeerdMat,
    defectenInzetbaar,
    defectenBeperktInzetbaar,
    defectenNietInzetbaar,
    defectenInOnderhoud,
    reserves,
    voorraadKnoop,
  };
}
